// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d3mor","footer":"styles_footer__UQuaS"};